import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'irar-north-farm-map',
  template: `
  <maphilight
    id="NorthMap"
    [config]="config">
      <img src="../images/NorthFarm.jpg"
        class="map"
        usemap="#NorthFarmArea"
        alt="Beltsville Agricultural Research Center North Farm"
        height="587"
        width="760"
        border="0">
      <map name="NorthFarmArea">
        <area (click)="selectSite.emit('BARC 3')"
          alt="BARC 3"
          shape="rect"
          coords="57,261,99,274">
        <area (click)="selectSite.emit('BARC 4')"
          alt="BARC 4"
          shape="rect"
          coords="305,121,345,135">
        <area (click)="selectSite.emit('BARC 5')"
          alt="BARC 5"
          shape="rect"
          coords="106,358,147,373">
        <area (click)="selectSite.emit('BARC 18')"
          alt="BARC 18"
          shape="rect"
          coords="133,401,180,415">
        <area (click)="selectSite.emit('BARC 19')"
          alt="BARC 19"
          shape="rect"
          coords="83,190,132,205">
        <area (click)="selectSite.emit('ENTECH M6')"
          alt="ENTECH M6"
          shape="rect"
          coords="189,157,249,172">
        <area (click)="selectSite.emit('ENTECH 3')"
          alt="ENTECH 3"
          shape="rect"
          coords="628,430,682,444">
        <area (click)="selectSite.emit('EPIC 7')"
          alt="EPIC 7"
          shape="rect"
          coords="397,160,433,174">
        <area (click)="selectSite.emit('EPIC 8')"
          alt="EPIC 8"
          shape="rect"
          coords="575,266,611,279">
        <area (click)="selectSite.emit('EPIC 9')"
          alt="EPIC 9"
          shape="rect"
          coords="491,156,526,170">
        <area (click)="selectSite.emit('EPIC 11')"
          alt="EPIC 11"
          shape="rect"
          coords="531,469,573,482">
      </map>
    </maphilight>
  `
})
export class NorthFarmMapComponent {
  @Input() config: any;
  @Output() selectSite: EventEmitter<string> = new EventEmitter();
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/components/north-farm-map.ts